import React from "react";
import Button from "@material-ui/core/Button";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  List,
  ListItem,
  Box,
} from "@material-ui/core";
import { resetForm } from "../../state/ducks/form";
import { useSelector } from "react-redux";
import { useAppSetting } from "../../context/appSettingContext.js";
import { useClientInboundConfigs } from "../../hooks/useClientInboundConfigs";
import { useTenantFaxLines } from "../../hooks/useTenantFaxLines";

export const determineExportMethod = (exportConfig) => {
  if (!exportConfig) {
    return "Not Configured";
  }

  const { exportType = null, exportValue = null } = exportConfig;

  if (exportType === "HL7 ORU") {
    return "ORU";
  }

  return exportType === "Fax"
    ? `Fax: ${exportValue}`
    : `Direct Address: ${exportValue}`;
};

const SettingsDialog = ({ open, onClose }) => {
  const clientId = useSelector((state) => state.auth.clientId);

  const { inboundConfigs: directAddressList } =
    useClientInboundConfigs(clientId);

  const { tenantDids: inboundFaxNumberList } = useTenantFaxLines(clientId);

  const { exportConfig = null, clientName: orgName } = useAppSetting();

  return (
    <Dialog
      open={open}
      maxWidth="lg"
      onClose={() => {
        onClose();
        resetForm();
      }}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">Settings</DialogTitle>
      <DialogContent>
        <DialogContentText>{orgName}</DialogContentText>
        <Box>
          <Typography variant="body1">TenantId:</Typography>
          <List>
            <ListItem>{clientId}</ListItem>
          </List>
          <Typography variant="body1">Inbound Fax Numbers:</Typography>
          <List>
            {inboundFaxNumberList.length > 0 ? (
              inboundFaxNumberList.map((fax) => (
                <ListItem key={fax.did}>{fax.did}</ListItem>
              ))
            ) : (
              <ListItem key="fax_no_data">No inbound fax numbers</ListItem>
            )}
          </List>
          <Typography variant="body1">Import Direct Addresses:</Typography>
          <List>
            {directAddressList.length > 0 ? (
              directAddressList.map((address) => (
                <ListItem key={address.address}>{address.address}</ListItem>
              ))
            ) : (
              <ListItem key="fax_no_data">No direct addresses</ListItem>
            )}
          </List>
          <Typography variant="body1">My Export Method:</Typography>
          <List>
            <ListItem>{determineExportMethod(exportConfig)}</ListItem>
          </List>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose();
          }}
          color="primary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SettingsDialog;
